module.exports = __webpack_public_path__ + "static/img/sss.b730d9f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/shangwu/sss.png
// module id = ZDtw
// module chunks = 1